module.exports = __webpack_public_path__ + "img/coordinate-sample-graph.b4583e59.png";